module.exports = __webpack_public_path__ + "img/courseimg2.7284c210.png";